<template>
    <div class="tab-group">
        <div class="tab-group-wrapper">
            <ul class="tab-group__content">
                <li class="tab-item">
                    <router-link to="/systemSettingOrganizationManageBaseInfo">基础信息</router-link>
                </li>
                <!-- <li class="tab-item">
                  <router-link to="/systemSettingOrganizationManageOrganizationAndUser">部门和用户</router-link>
                </li>
                <li class="tab-item">
                  <router-link to="/systemSettingOrganizationManageOrganizationAndVehicle">部门和车辆</router-link>
                </li>-->
            </ul>
        </div>
    </div>
</template>

<script>
    export default {};
</script>

<style lang="scss" scoped>
    .tab-group {
        border-bottom: 1px solid #e4e7ed;
        padding-top: 20px;
        margin: 0 20px;
        .tab-group-wrapper {
            position: relative;
            background-color: #f5f7fa;
            overflow: hidden;
        }
        .tab-group__content {
            border: 1px solid #e4e7ed;
            border-bottom: none;
            border-radius: 4px 4px 0 0;
            box-sizing: border-box;
            .tab-item {
                position: relative;
                display: inline-block;
                height: 40px;
                color: #303133;
                line-height: 40px;
                list-style: none;
                box-sizing: border-box;
                font: {
                    size: 14px;
                    weight: 500;
                }
                a {
                    display: block;
                    padding: 0 20px;
                    color: #303133;
                }
                .router-link-exact-active {
                    border-right-color: #dcdfe6;
                    border-left-color: #dcdfe6;
                    background-color: #fff;
                    color: #5b99e6;
                }
            }
        }
    }
</style>
